import { RankPrintType } from "@bujus/common";
import { Typography } from "@mui/material";
import React from "react";

import { CardRadioSelect } from "@/base";

const formatItem = (rankPrintType) => {
    switch (rankPrintType) {
        case RankPrintType.RANK:
            return (
                <>
                    <Typography fontWeight="bold">
                        Rang (z. B. &bdquo;1&ldquo;)
                    </Typography>
                    <Typography color="text.secondary" mt={2}>
                        Zeigt nur den Rang, ohne Riegen-Größe. Niedrigere Zahl =
                        bessere Platzierung.
                    </Typography>
                </>
            );
        case RankPrintType.RANK_WITH_GROUP_SIZE:
            return (
                <>
                    <Typography fontWeight="bold">
                        Rang mit Riegen-Größe (z. B. &bdquo;1 von 15&ldquo;)
                    </Typography>
                    <Typography color="text.secondary" mt={2}>
                        Zeigt den Rang innerhalb der Riege. Niedrigere
                        Zahl = bessere Platzierung.
                    </Typography>
                </>
            );
        case RankPrintType.MIRRORED_RANK:
            return (
                <>
                    <Typography fontWeight="bold">
                        Gespiegelter Rang (z. B. &bdquo;15&ldquo;)
                    </Typography>
                    <Typography color="text.secondary" mt={2}>
                        Zeigt nur den Rang, ohne Riegen-Größe, aber in umgekehrter Reihenfolge. Höhere Zahl = bessere Platzierung.
                    </Typography>
                </>
            );
        case RankPrintType.MIRRORED_RANK_WITH_GROUP_SIZE:
            return (
                <>
                    <Typography fontWeight="bold">
                        Gespiegelter Rang mit Riegen-Größe (z. B. &bdquo;15 von 15&ldquo;)
                    </Typography>
                    <Typography color="text.secondary" mt={2}>
                        Zeigt den Rang innerhalb der Riege, aber in umgekehrter Reihenfolge. Höhere Zahl = bessere Platzierung.
                    </Typography>
                </>
            );
        case RankPrintType.FAKE_POINTS:
            return (
                <>
                    <Typography fontWeight="bold">
                        Verborgene Punkte (z. B. 48)
                    </Typography>
                    <Typography color="text.secondary" mt={2}>
                        Zeigt eine Punktzahl statt eines Rangs. Höhere Zahl = bessere Platzierung. Berechnung: gespiegelte Rang-Summe × 3, plus 36 als Basis. So bekommt selbst der letzte Platz mindestens 48 Punkte und damit nie eine optisch niedrige Zahl. Außerdem sind die Punkte der Teilnehmer weiter auseinander und können nicht mehr so leicht verglichen werden.
                    </Typography>
                </>
            );
        default:
            throw new Error(`Invalid rank print type: ${rankPrintType}`);
    }
};

const RankPrintTypeSelect = ({ fieldName, isEnabled, label }) => (
    <CardRadioSelect
        fieldName={fieldName}
        // eslint-disable-next-line react/no-unstable-nested-components
        formatItem={formatItem}
        isEnabled={isEnabled}
        items={Object.values(RankPrintType)}
        label={label}
    />
);

export { RankPrintTypeSelect };
